import { gql } from 'apollo-angular';
import { CategoryParams } from '../categories-graphql.service';

const GET_PRODUCTS_IN_CATEGORY_BY_SEARCH = (categoryParams: CategoryParams) => {
  return gql`
    query getProductsInCategoryBySearch{
      optimizedPurchasedProducts (
        ${
          categoryParams.CONSUME_PRODUCT_DATA_MD_CAT_964488
            ? 'addHeaderProduct: true'
            : ''
        }
        ${
          categoryParams.CONSUME_PRODUCT_DATA_MD_CAT_964488 &&
          categoryParams.variant
            ? 'variant: "' + categoryParams.variant + '"'
            : ''
        }
        ${
          categoryParams.categorizationSchemeId
            ? 'categorizationSchemeId: ' + categoryParams.categorizationSchemeId
            : ''
        }
        ${
          categoryParams.categoryId
            ? 'categoryId: ' + categoryParams.categoryId
            : ''
        }
        ${
          categoryParams.searchTerm
            ? ', searchValue: "' + categoryParams.searchTerm + '"'
            : ''
        }
      ) {
        id,
        brandName,
        catalogNumber,
        description,
        packageString,
        productSource,
        ${
          categoryParams.CONSUME_PRODUCT_DATA_MD_CAT_964488
            ? `
          baseProductId
          manufacturerCatalogNumber
          supplierType
          manufacturer {
              id
              name
          }
          parentManufacturer {
            id
            name
          }
          distributor {
              id
              name
          }
          parentDistributor {
            id
            name
          }
          approxSpend {
            value
            isMasked
          }
          approxUnit {
            value
            isMasked
          }
          `
            : ''
        }
        status,
        aptitudeCategory {
          id,
          name
        },
        categories {
          id,
          name,
          parents {
            id,
            name
          }
        },
        statistics {
          crossReferenceStatistic {
            approveCount,
            disputeCount,
            crossCount,
            crossCountBySellers {
              seller {
                  id,
                  name
              },
              crossCount
            }
          }
        },
        seller {
          id,
          name
        },
        sysSeller {
          id,
          name
        },
        spend {
          actualSpend,
          continuedSpend
        }
      }
    }
  `;
};

export default GET_PRODUCTS_IN_CATEGORY_BY_SEARCH;
